<template>
  <div class="table_container">
    <div class="table-btn" style="margin: 24px 0 12px 0">
      <el-button
        v-if="$route.query.operateType !== '查看'"
        :disabled="tableData.length >= 15"
        type="primary"
        size="small"
        @click="handleAdd()"
        >添加</el-button
      >
    </div>
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 品牌 -->
      <el-table-column
        prop="brand"
        label="品牌"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'brand' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.brand"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.brand }}
          </div>
        </template>
      </el-table-column>
      <!-- 进入时间 -->
      <el-table-column
        prop="joinTime"
        label="进入时间"
        min-width="110px"
        align="center"
      >
        <template slot-scope="scope">
          <el-date-picker
            v-if="editField === 'joinTime' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.joinTime"
            type="year"
            value-format="yyyy"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @change="confirmEdit"
          >
          </el-date-picker>
          <div v-else>
            {{ scope.row.joinTime }}
          </div>
        </template>
      </el-table-column>
      <!-- 合作伙伴 -->
      <el-table-column
        prop="partnershipPartner"
        label="合作伙伴"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'partnershipPartner' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.partnershipPartner"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.partnershipPartner }}
          </div>
        </template>
      </el-table-column>
      <!-- 合作伙伴性质 -->
      <el-table-column
        prop="partnershipPartnerNature"
        label="合作伙伴性质"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-select
            v-if="
              editField === 'partnershipPartnerNature' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.partnershipPartnerNature"
            placeholder="请选择"
            filterable
            clearable
            size="mini"
            automatic-dropdown
            @visible-change="visibleChange"
            @change="confirmEdit"
          >
            <el-option label="国营" value="国营"></el-option>
            <el-option label="私营" value="私营"></el-option>
          </el-select>
          <div v-else>
            {{ scope.row.partnershipPartnerNature }}
          </div>
        </template>
      </el-table-column>
      <!-- 合作模式 -->
      <el-table-column
        prop="cooperationModel"
        label="合作模式"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'cooperationModel' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.cooperationModel"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.cooperationModel }}
          </div>
        </template>
      </el-table-column>
      <!-- 图片 -->
      <el-table-column prop="img" label="图片" min-width="90px" align="center">
        <template slot-scope="scope">
          <upload-img
            action="/manage/saleChannelController/upload/file"
            v-model="scope.row.img"
            accept=".jpg,.png,.jpeg"
            :limit="1"
            :disabled="$route.query.operateType === '查看'"
          >
          </upload-img>
        </template>
      </el-table-column>
      <!-- 生产供应模式 -->
      <el-table-column
        prop="productionSupplyMode"
        label="生产供应模式"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-select
            v-if="
              editField === 'productionSupplyMode' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.productionSupplyMode"
            placeholder="请选择"
            filterable
            clearable
            size="mini"
            automatic-dropdown
            @visible-change="visibleChange"
            @change="confirmEdit"
          >
            <el-option label="CBU" value="CBU"></el-option>
            <el-option label="SKD" value="SKD"></el-option>
            <el-option label="CKD" value="CKD"></el-option>
          </el-select>
          <div v-else>
            {{ scope.row.productionSupplyMode }}
          </div>
        </template>
      </el-table-column>
      <!-- 销售模式 -->
      <el-table-column
        prop="saleMode"
        label="销售模式"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-select
            v-if="editField === 'saleMode' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.saleMode"
            placeholder="请选择"
            filterable
            clearable
            size="mini"
            automatic-dropdown
            @visible-change="visibleChange"
            @change="confirmEdit"
          >
            <el-option label="直营" value="直营"></el-option>
            <el-option label="分销" value="分销"></el-option>
            <el-option label="混合" value="混合"></el-option>
          </el-select>
          <div v-else>
            {{ scope.row.saleMode }}
          </div>
        </template>
      </el-table-column>
      <!-- 直营网点和二级网点合计 -->
      <el-table-column label="直营网点和二级网点合计" align="center">
        <!-- 网点数量 -->
        <el-table-column label="网点数量" min-width="90px" align="center">
          <template slot-scope="scope">
            <div>
              {{ getTotal(scope.row, "outletsNumber") }}
            </div>
          </template>
        </el-table-column>
        <!-- 品牌专营店数量 -->
        <el-table-column label="品牌专营店数量" min-width="90px" align="center">
          <template slot-scope="scope">
            <div>
              {{ getTotal(scope.row, "brandFranchiseNumber") }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 直营网点 -->
      <el-table-column label="直营网点" align="center">
        <!-- 网点数量 -->
        <el-table-column
          prop="directOutletsNumber"
          label="网点数量"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                editField === 'directOutletsNumber' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.directOutletsNumber"
              class="number_input"
              :controls="false"
              :precision="0"
              :min="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.directOutletsNumber }}
            </span>
          </template>
        </el-table-column>
        <!-- 品牌专营店数量 -->
        <el-table-column
          prop="brandFranchiseNumber"
          label="品牌专营店数量"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                editField === 'brandFranchiseNumber' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.brandFranchiseNumber"
              class="number_input"
              :controls="false"
              :precision="0"
              :min="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.brandFranchiseNumber }}
            </span>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 二级网点 -->
      <el-table-column label="二级网点" align="center">
        <!-- 网点数量 -->
        <el-table-column
          prop="secondOutletsNumber"
          label="网点数量"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                editField === 'secondOutletsNumber' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.secondOutletsNumber"
              class="number_input"
              :controls="false"
              :precision="0"
              :min="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.secondOutletsNumber }}
            </span>
          </template>
        </el-table-column>
        <!-- 品牌专营店数量 -->
        <el-table-column
          prop="secondBrandFranchiseNumber"
          label="品牌专营店数量"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input-number
              v-if="
                editField === 'secondBrandFranchiseNumber' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.secondBrandFranchiseNumber"
              class="number_input"
              :controls="false"
              :precision="0"
              :min="0"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            >
            </el-input-number>
            <span v-else>
              {{ scope.row.secondBrandFranchiseNumber }}
            </span>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 售后服务站数量 -->
      <el-table-column
        prop="afterSaleServiceNumber"
        label="售后服务站数量"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input-number
            v-if="
              editField === 'afterSaleServiceNumber' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.afterSaleServiceNumber"
            class="number_input"
            :controls="false"
            :precision="0"
            :min="0"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          >
          </el-input-number>
          <span v-else>
            {{ scope.row.afterSaleServiceNumber }}
          </span>
        </template>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        prop="competitiveBrandDescription"
        label="备注"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'competitiveBrandDescription' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.competitiveBrandDescription"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.competitiveBrandDescription }}
          </div>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column
        v-if="$route.query.operateType !== '查看'"
        label="操作"
        align="center"
        width="90px"
        fixed="right"
      >
        <template slot-scope="scope">
          <!-- 删除 -->
          <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import UploadImg from "@/components/uploadImgTable.vue";
import { addOrUpdateMainCompetitorApi } from "@/api/saleTaskCollection";

export default {
  components: { UploadImg },
  data() {
    return {
      tableData: [],
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data) {
      this.tableData = [];
      if (data) {
        data.map(item => {
          this.tableData.push({
            ...item,
            img: item.img ? item.img.split(",") : []
          });
        });
      }
    },
    // 添加
    handleAdd() {
      this.tableData.push({
        brand: "",
        joinTime: "",
        partnershipPartner: "",
        partnershipPartnerNature: "",
        cooperationModel: "",
        img: [],
        productionSupplyMode: "",
        saleMode: "",
        directOutletsNumber: undefined,
        brandFranchiseNumber: undefined,
        sencondOutletsNumber: undefined,
        sencondBrandFranchiseNumber: undefined,
        afterSaleServiceNumber: undefined,
        competitiveBrandDescription: ""
      });
    },
    // 删除
    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    // 合计
    getTotal(data, type) {
      if (type === "outletsNumber") {
        return (
          (data.directOutletsNumber ? data.directOutletsNumber : 0) +
          (data.secondOutletsNumber ? data.secondOutletsNumber : 0)
        );
      }
      if (type === "brandFranchiseNumber") {
        return (
          (data.brandFranchiseNumber ? data.brandFranchiseNumber : 0) +
          (data.secondBrandFranchiseNumber
            ? data.secondBrandFranchiseNumber
            : 0)
        );
      }
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      if (this.$route.query.operateType === "查看") return;
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(params) {
      try {
        const submitData = {
          ...params,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        submitData.dataList.map((item, index) => {
          submitData.dataList[index].img = item.img?.join(",");
        });
        const res = await addOrUpdateMainCompetitorApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = [];
          res.data.map(item => {
            this.tableData.push({
              ...item,
              img: item.img ? item.img.split(",") : []
            });
          });
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
